import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { handleSearchParams } from "@/api/handleSearchParams";
import { API_URL } from "@/constants/envVariables";
import { fetchApi } from "@/helpers/fetchApi";
import { AppError, MultisigAuditLogResponse, MultisigAuditLogSearchParams } from "@/types";

export const useMultisigAuditLogs = (
  searchParams?: MultisigAuditLogSearchParams,
  options?: Omit<UseQueryOptions<MultisigAuditLogResponse, AppError>, "queryKey" | "queryFn">,
) => {
  const params = handleSearchParams(searchParams);

  return useQuery<MultisigAuditLogResponse, AppError>({
    queryKey: ["multisigAuditLogs", { ...searchParams }],
    queryFn: async () => {
      return await fetchApi(`${API_URL}/multisig/audit-log${params}`);
    },
    placeholderData: (prev) => prev,
    ...options,
  });
};
